import React from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/chevron-left.svg'
import s from './styles/Calendar.module.scss'

const Calendar = ({
	isOpen,
	style,
	calendarRef,

	title,
	weekdays = [],
	gridDays = [],

	onPrev,
	onNext,
	onSelectDay,
	onClose,

	isSelectedDay,
	isToday,
	isDisabledDay,
}) => {
	if (!isOpen || !style) return null

	return createPortal(
		<div
			ref={calendarRef}
			className={s.calendar}
			style={{ top: style.top, left: style.left, width: style.width }}
			role="dialog"
			aria-label="Calendar"
			onWheel={e => e.stopPropagation()}
			onTouchMove={e => e.stopPropagation()}
		>
			<div className={s.calendarHead}>
				<button
					type="button"
					className={s.calNavBtn}
					onClick={onPrev}
					aria-label="Previous month"
				>
					<span className={s.calNavIcon} aria-hidden="true">
						<ChevronLeftIcon />
					</span>
				</button>

				<div className={s.calTitle}>{title}</div>

				<button
					type="button"
					className={s.calNavBtn}
					onClick={onNext}
					aria-label="Next month"
				>
					<span className={`${s.calNavIcon} ${s.calNavIconNext}`} aria-hidden="true">
						<ChevronLeftIcon />
					</span>
				</button>
			</div>

			<div className={s.calendarWeekdays}>
				{weekdays.map(w => (
					<div key={w} className={s.calWeekday}>
						{w}
					</div>
				))}
			</div>

			<div className={s.calendarGrid}>
				{gridDays.map((d, idx) => {
					if (!d) return <div key={idx} className={s.calCell} />

					const disabled = isDisabledDay?.(d.iso)
					const selected = isSelectedDay?.(d.iso)
					const today = isToday?.(d.iso)

					return (
						<button
							key={d.iso}
							type="button"
							className={[
								s.calDay,
								selected ? s.calDaySelected : '',
								today ? s.calDayToday : '',
							]
								.filter(Boolean)
								.join(' ')}
							onClick={() => onSelectDay?.(d.iso)}
							disabled={disabled}
							aria-label={d.aria}
						>
							{d.day}
						</button>
					)
				})}
			</div>

			<div className={s.calendarFooter}>
				<button type="button" className={s.calCloseBtn} onClick={onClose}>
					Close
				</button>
			</div>
		</div>,
		document.body
	)
}

export default Calendar
